import React, { useEffect, useState } from 'react';
import AuthHeader from '../../UI/AuthHeader/AuthHeader';
import AuthSideMenu from '../../UI/AuthSideMenu/AuthSideMenu';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Button from '../../UI/Buttons/Button';
import { ButtonSubmitGreen } from '../../UI/Buttons/Buttons';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { Grid, Box } from '@mui/material';
import { useDispatch } from 'react-redux';
import { setFetching } from '../../../redux/states';
import { useErrorSetter, useSuccessSetter } from '../../../hooks/useUiMessages';
import {checkAuthenticatedUser} from '../../../utils/client-functions';
import BubbleFloat from '../../UI/BubbleFloat/BubbleFloat';
import { useTheme } from '../../UI/Theme/ThemeContext';
import { FaEye } from 'react-icons/fa';
import PageHeaderStyled from '../../../styled/PageHeader';
import { IoMdRemoveCircle } from 'react-icons/io';
import { MdOutlineInsights } from 'react-icons/md';
import { useConfirm } from 'material-ui-confirm';

const SimulatedExams = () => {
    const [authMenuOpen, setAuthMenuOpen] = useState(false);
    const toggleAuthMenu = () => setAuthMenuOpen(!authMenuOpen);
    const [exams, setExams] = useState([]);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const errorSetter = useErrorSetter();
    const successSetter = useSuccessSetter();
    const { themeName } = useTheme();

    const fetchExams = async () => {
        dispatch(setFetching(true));
        try {
            const token = localStorage?.getItem('token');
            const resp = await axios.get('/mock/list-exams', { headers: { 'x-access-token': token } });
            setExams(resp?.data?.exams || []);
        } catch (err) {
            errorSetter(err?.response?.data?.error || 'Failed to load exams');
        } finally {
            dispatch(setFetching(false));
        }
    };

    useEffect(() => {
        const verifyAuth = async () => {
            try {
                await checkAuthenticatedUser();
            } catch (error) { errorSetter("Please login to access mock exams"); sessionStorage.setItem("prevPath", window.location.pathname); navigate("/popin"); }
        };
        verifyAuth();
        fetchExams();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const confirm = useConfirm();

    const handleDelete = async (examId) => {
        // Use material-ui-confirm dialog for consistent UX
        confirm({
            title: 'Delete Exam?',
            description: 'This action cannot be undone. Click OK to delete the exam.'
        })
        .then(async () => {
            dispatch(setFetching(true));
            try {
                const token = localStorage?.getItem('token');
                await axios.delete('/mock/delete-exam', { params: { examId }, headers: { 'x-access-token': token } });
                setExams(prev => prev.filter(e => e.examId !== examId));
                successSetter('Exam deleted');
            } catch (err) {
                errorSetter(err?.response?.data?.error || 'Failed to delete exam');
            } finally {
                dispatch(setFetching(false));
            }
        })
        .catch(() => {
            // user cancelled
        });
    };

    return (
        <div className="auth-container">
            <BubbleFloat />
            <div className="auth-container-inner">
                <AuthHeader authMenuOpen={authMenuOpen} onClick={toggleAuthMenu} headerText="Simulated Exams" />
                <AuthSideMenu opened={authMenuOpen} arrayDetails={[]} onSwitch={() => {}} />

                <div style={{ padding: '1rem', width: '100%' }}>
                    <PageHeaderStyled theme={themeName}>Your Written Exams</PageHeaderStyled>
                    <Grid container spacing={2}>
                        {exams.length === 0 && (
                            <>
                                <div style={{ padding: '1rem', textAlign: 'center', width: '100%' }}>
                                    <span style={{ color: themeName === 'dark' ? '#fff' : 'inherit', display: 'block', textAlign: 'center' }}>No exams found.</span>
                                </div>

                                <div style={{ display: 'flex', justifyContent: 'center', width: '80%', margin: '1rem auto' }}>
                                    <ButtonSubmitGreen onClick={() => navigate('/user/dashboard/mock')}>Start New Mock</ButtonSubmitGreen>
                                </div>
                            </>
                        )}
                        {exams.map((exam) => (
                            <Grid item xs={12} md={6} key={exam.examId}>
                                <Card sx={{ borderRadius: '20px', padding: '10px', backgroundColor: 'transparent', border: `1px solid ${themeName === 'dark' ? '#17333b' : '#e6f7f6'}` }}>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                                                <Box sx={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                                                    <Box sx={{ flex: '1 1 auto', display: 'flex', flexDirection: 'column' }}>
                                                        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
                                                            <CardContent sx={{ flex: '1 0 auto', paddingRight: 2 }}>
                                                                <Typography component="div" variant="h5" sx={{ color: themeName === 'dark' ? '#fff' : '#000' }}>
                                                                    {exam.examName ? (exam.examName.length > 40 ? `${exam.examName.slice(0, 40)}...` : exam.examName) : 'Untitled Exam'}
                                                                </Typography>
                                                                <Typography sx={{ fontSize: '.9rem', color: themeName === 'dark' ? '#fff' : '#000' }}>
                                                                    Subject: {exam.subject || '—'}
                                                                </Typography>
                                                                <Typography sx={{ fontSize: '.85rem', color: themeName === 'dark' ? '#fff' : '#333' }}>
                                                                    Date: {exam.dateTaken ? new Date(exam.dateTaken).toLocaleString() : 'Unknown'}
                                                                </Typography>
                                                                <Typography sx={{ fontSize: '.85rem', color: themeName === 'dark' ? '#fff' : '#333' }}>
                                                                    Score: {exam.score ?? (exam.grading && exam.grading.score) ?? '—'}
                                                                </Typography>
                                                            </CardContent>

                                                            <Box sx={{ width: 140, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                <MdOutlineInsights size={92} color={themeName === 'dark' ? '#3E8F93' : '#3E8F93'} />
                                                            </Box>
                                                        </Box>

                                                        <div style={{ display: 'flex', justifyContent: 'space-around', paddingTop: '0.75rem', paddingBottom: '1rem', flexWrap: 'wrap', gap: '10px', width: '100%', margin: '0 auto' }}>
                                                            <div style={{ flex: '1 1 auto' }}>
                                                                <Button
                                                                    width="100%"
                                                                    secondaryLight={true}
                                                                    color="#3E8F93"
                                                                    $borderColor="#3E8F93"
                                                                    link={`/user/dashboard/mock/exam-insight?examId=${encodeURIComponent(exam.examId)}`}
                                                                >
                                                                    <FaEye style={{ color: '#3E8F93', fontSize: '.9rem' }} />&nbsp;&nbsp; View Insight
                                                                </Button>
                                                            </div>
                                                            <div style={{ flex: '1 1 auto' }}>
                                                                <Button
                                                                    width="100%"
                                                                    secondaryLight={true}
                                                                    color="rgba(158, 9, 9, 0.733)"
                                                                    $borderColor="rgba(158, 9, 9, 0.733)"
                                                                    clickHandle={() => handleDelete(exam.examId)}
                                                                >
                                                                    <IoMdRemoveCircle style={{ color: 'rgba(158, 9, 9, 0.733)', fontSize: '.9rem' }} />&nbsp;&nbsp; Delete
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    </Box>
                                                </Box>
                                    </Box>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>

                </div>

            </div>
        </div>
    );
};

export default SimulatedExams;

